import './styles/log-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import { formatTime } from './utils'

export default class LogItem extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
  }

  render() {
    const { item } = this.props
    
    const time = formatTime(item.timestamp)

    return (
      <div className="log-item">
        <div className="time">
          { time }
        </div>

        <div className="content">
          {
            item.failed && (
              <div className="item-highlight ui mini message error">
                <div className="title">FAILED</div>          
              </div>  
            )
          }

          {
            item.pollingInterval && (
              <div className="item-highlight ui mini message">
                <div className="title">Polling Interval</div>
                <div className="message">{ `${item.pollingInterval} minutes` }</div>
              </div>
            )
          }

          {
            item.region && (
              <div className="item-highlight ui mini message">
                <div className="title">Region</div>
                <div className="message">{ item.region }</div>
              </div>
            )
          }
        </div>
      </div>
    )
  }
}